import React from 'react';
import { Card, Form, Row, Col } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { TextFormFieldRow } from '@rd-web-markets/shared/dist/util/form';
import Dropdown from '@rd-web-markets/shared/dist/util/Dropdown';

const COUNTRY_OPTIONS = [
  { key: '', value: null, text: '' },
  { key: 'germany', value: 'germany', text: 'Germany' },
  { key: 'italy', value: 'italy', text: 'Italy' },
  { key: 'usa', value: 'usa', text: 'USA' },
  { key: 'mexcico', value: 'mexcico', text: 'Mexico' },
  { key: 'russia', value: 'russia', text: 'Russia' }
];

const FEDERAL_STATE_OPTIONS = [
  { key: '', value: null, text: '' },
  { key: 'baden_wuerttemberg', value: 'baden_wuerttemberg', text: 'Baden-Wuerttemberg' },
  { key: 'bayern', value: 'bayern', text: 'Bayern' },
  { key: 'berlin', value: 'berlin', text: 'Berlin' },
  { key: 'brandenburg', value: 'brandenburg', text: 'Brandenburg' },
  { key: 'bremen', value: 'bremen', text: 'Bremen' },
  { key: 'hamuburg', value: 'hamuburg', text: 'Hamburg' },
  { key: 'hesse', value: 'hesse', text: 'Hesse' },
  { key: 'mecklenburg_vorpommern', value: 'mecklenburg_vorpommern', text: 'Mecklenburg-Vorpommern' },
  { key: 'lower_saxony', value: 'lower_saxony', text: 'Lower Saxony' },
  { key: 'north_rhine_westphalia', value: 'north_rhine_westphalia', text: 'North Rhine-Westphalia' },
  { key: 'rheinland_pfalz', value: 'rheinland_pfalz', text: 'Rheinland-Pfalz' },
  { key: 'saarland', value: 'saarland', text: 'Saarland' },
  { key: 'saxony', value: 'saxony', text: 'Saxony' },
  { key: 'saxony_anhalt', value: 'saxony_anhalt', text: 'Saxony-Anhalt' },
  { key: 'schleswig_holstein', value: 'schleswig_holstein', text: 'Schleswig-Holstein' },
  { key: 'thuringia', value: 'thuringia', text: 'Thuringia' }
];

const LEGAL_FORM_OPTIONS = [
  { key: '', value: null, text: '' },
  { key: 'aktiengesellschaft', value: 'aktiengesellschaft', text: 'Aktiengesellschaft (AG)' },
  { key: 'aktiengesellschaft_kg', value: 'aktiengesellschaft_kg', text: 'Aktiengesellschaft und Co. KG (AG u. Co. KG)' },
  { key: 'aktiengesellschaft_ohg', value: 'aktiengesellschaft_ohg', text: 'Aktiengesellschaft und Co. OHG (AG & Co. OHG)' },
  { key: 'kapitalgesellschaft', value: 'kapitalgesellschaft', text: 'Ausländische Rechtsform die einer Kapitalgesellschaft entspricht' },
  { key: 'personengesellschaft', value: 'personengesellschaft', text: 'Ausländische Rechtsform die einer Personengesellschaft entspricht' },
  { key: 'eingetragene_gennosenchaft', value: 'eingetragene_gennosenchaft', text: 'Eingetragene Genossenschaft (eG)' },
  { key: 'eingetragener_verein', value: 'eingetragener_verein', text: 'Eingetragener Verein (e.V.)' },
  { key: 'einzelunternehmer', value: 'einzelunternehmer', text: 'Einzelunternehmer' },
  { key: 'juristische_person', value: 'juristische_person', text: 'Juristische Person des Öffentlichen Rechts' },
  { key: 'europäische_gesellschaft', value: 'europäische_gesellschaft', text: 'Europäische Gesellschaft (SE)' },
  { key: 'europäische_wirtschaftliche', value: 'europäische_wirtschaftliche', text: 'Europäische Wirtschaftliche Interessenvereinigung (EWIV)' },
  { key: 'gesellschaft_haftung', value: 'gesellschaft_haftung', text: 'Gesellschaft mit beschränkter Haftung (GmbH)' },
  { key: 'gesellschaft_haftung_kg', value: 'gesellschaft_haftung_kg', text: 'Gesellschaft mit beschränkter Haftung und Co. KG (GmbH & Co. KG)' },
  { key: 'gesellschaft_haftung_ohg', value: 'gesellschaft_haftung_ohg', text: 'Gesellschaft mit beschränkter Haftung und Co. OHG (GmbH & Co. OHG)' },
  { key: 'gbr', value: 'gbr', text: 'Gesellschaft des bürgerlichen Rechts (GbR)' },
  { key: 'kommanditgesellschaft', value: 'kommanditgesellschaft', text: 'Kommanditgesellschaft (KG)' },
  { key: 'kommanditgesellschaft_afu_aktien', value: 'kommanditgesellschaft_afu_aktien', text: 'Kommanditgesellschaft auf Aktien (KGaA)' },
  { key: 'ohg', value: 'ohg', text: 'Offene Handelsgesellschaft (OHG)' },
  { key: 'partnerschaft', value: 'partnerschaft', text: 'Partnerschaft' },
  { key: 'sonstige_ausländische_rechtsform', value: 'sonstige_ausländische_rechtsform', text: 'Sonstige ausländische Rechtsform' },
  { key: 'sonstige_personengesellschaft', value: 'sonstige_personengesellschaft', text: 'Sonstige Personengesellschaft' }
];

const YES_NO_OPTIONS = [
  { key: '', value: null, text: '' },
  { key: 'true', value: 'true', text: 'Yes' },
  { key: 'false', value: 'false', text: 'No' }
];

const AffiliatedCompaniesForm = ({ affiliatedCompany, handleChange, handleSubmit, loading, closeForm }) => {
  return (
    <Card>
      <Card.Body>
        <Form>
          <TextFormFieldRow
            fieldName="name"
            label="Company's Name"
            value={affiliatedCompany.name}
            onChange={handleChange}
            placeholder="Company Name"
            required
            dataTestId="affiliated_company_name"
          />

          <Form.Group className="mb-2" as={Row}>
            <Form.Label column="md" md={3}>
              <span className="font-weight-bold">Legally billing address: </span>
            </Form.Label>
          </Form.Group>

          <Row className="mb-3">
            <Col md={4}>
              <TextFormFieldRow
                fieldName="street"
                label="Street"
                value={affiliatedCompany.street}
                onChange={handleChange}
                placeholder="Street"
                dataTestId="affiliated_company_street"
              />
            </Col>
            <Col md={4}>
              <TextFormFieldRow
                fieldName="house_number"
                label="House Number"
                value={affiliatedCompany.house_number}
                onChange={handleChange}
                placeholder="House Number"
                dataTestId="affiliated_company_house_number"
              />
            </Col>
            <Col md={4}>
              <TextFormFieldRow
                fieldName="house_number_suppliment"
                label="Additional House Number Details"
                value={affiliatedCompany.house_number_suppliment}
                onChange={handleChange}
                placeholder="Additional House Number Details"
                dataTestId="affiliated_company_house_number_suppliment"
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <TextFormFieldRow
                fieldName="location"
                label="Location"
                value={affiliatedCompany.location}
                onChange={handleChange}
                placeholder="Location"
                dataTestId="affiliated_company_location"
              />
            </Col>
            <Col md={4}>
              <TextFormFieldRow
                fieldName="postcode"
                label="Post Code"
                value={affiliatedCompany.postcode}
                onChange={handleChange}
                placeholder="Postcode"
                dataTestId="affiliated_company_postcode"
              />
            </Col>
            <Col md={4}>
              <TextFormFieldRow
                fieldName="address_supliment"
                label="Additional Address Details"
                value={affiliatedCompany.address_supliment}
                onChange={handleChange}
                placeholder="Additional Address Details"
                dataTestId="affiliated_company_address_supliment"
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Dropdown
                name="country"
                fieldName="country"
                label="Country"
                value={affiliatedCompany.country}
                onChange={(val) => handleChange({ target: { name: 'country', value: val } })}
                options={COUNTRY_OPTIONS}
                dataTestId="affiliated_company_country"
                showNullOption={false}
              />
            </Col>
            {affiliatedCompany.country === 'germany' && (
              <Col md={6}>
                <Dropdown
                  name="federal_state"
                  fieldName="federal_state"
                  label="Federal State"
                  value={affiliatedCompany.federal_state}
                  onChange={(val) => handleChange({ target: { name: 'federal_state', value: val } })}
                  options={FEDERAL_STATE_OPTIONS}
                  dataTestId="affiliated_company_federal_state"
                  showNullOption={false}
                />
              </Col>
            )}
          </Row>

          {affiliatedCompany.country === 'germany' && (
            <Row className="mb-3">
              <Col md={6}>
                <Dropdown
                  name="legal_form"
                  fieldName="legal_form"
                  label="Legal Form"
                  value={affiliatedCompany.legal_form}
                  onChange={(val) => handleChange({ target: { name: 'legal_form', value: val } })}
                  options={LEGAL_FORM_OPTIONS}
                  dataTestId="affiliated_company_legal_form"
                  showNullOption={false}
                />
              </Col>
            </Row>
          )}

          <Dropdown
            name="has_tax_number"
            fieldName="has_tax_number"
            label="If the affiliated company also submits applications according to 6 FZulG, the tax number must be entered here. Would you like to provide a tax number ?"
            value={affiliatedCompany.has_tax_number}
            onChange={(val) => handleChange({ target: { name: 'has_tax_number', value: val } })}
            options={YES_NO_OPTIONS}
            labelColSpan={10}
            dataTestId="affiliated_company_has_tax_number"
            showNullOption={false}
          />

          {affiliatedCompany.has_tax_number?.toString() === 'true' && (
            <Dropdown
              name="state_of_tax_office"
              fieldName="state_of_tax_office"
              label="State of the Tax Office"
              value={affiliatedCompany.state_of_tax_office}
              onChange={(val) => handleChange({ target: { name: 'state_of_tax_office', value: val } })}
              options={FEDERAL_STATE_OPTIONS}
              dataTestId="affiliated_company_state_of_tax_office"
              showNullOption={false}
            />
          )}
        </Form>
      </Card.Body>
      <Card.Footer>
        <Row className="justify-content-end">
          <Button
            onClick={() => handleSubmit()}
            icon="save"
            iconPosition="left"
            loading={loading}
            variant="primary"
          >
            Save
          </Button>
          <Button
            className="ms-2"
            onClick={() => closeForm()}
            loading={loading}
            variant="light"
          >
            Close Form
          </Button>
        </Row>
      </Card.Footer>
    </Card>
  );
};

export default AffiliatedCompaniesForm;
